export default __webpack_public_path__ + "static/media/user5up.cf427a17.svg";